import {
  Input,
  InputElementProps,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement
} from "@chakra-ui/react";
import { omit } from "lodash/fp";
import React, { ReactNode, Ref } from "react";

import { colors } from "src/colors";
import { TEXT_STYLES } from "src/typography";

import { INPUT_STYLES } from "./styles";

export type OFInputProps = InputProps & {
  rightIcon?: ReactNode;
  leftIcon?: ReactNode;
  leftElementProps?: InputElementProps;
  rightElementProps?: InputElementProps;
};

export const OFInput = React.forwardRef(
  (
    {
      rightIcon,
      leftIcon,
      leftElementProps,
      rightElementProps,
      background,
      ...props
    }: OFInputProps,
    ref: Ref<HTMLInputElement>
  ) => {
    const styles = omit(["as", "fontSize"], TEXT_STYLES.body3);

    return (
      <InputGroup>
        {leftIcon && (
          <InputLeftElement h="100%" {...leftElementProps}>
            {leftIcon}
          </InputLeftElement>
        )}
        <Input
          {...INPUT_STYLES}
          fontFamily="graphik"
          bg={background || colors.white.default}
          {...styles}
          fontSize="16px"
          {...props}
          ref={ref}
        />
        {rightIcon && (
          <InputRightElement h="100%" {...rightElementProps}>
            {rightIcon}
          </InputRightElement>
        )}
      </InputGroup>
    );
  }
);
